import httpClient from './httpClient'
export default {
  async getTrafficBandwidth(startDate, endDate) {
    let ret = await httpClient.get(
      `/analytics/traffic?type=general&start_date=${startDate}&end_date=${endDate}&type=general`
    )
    return ret
  },
  async getVideoTrafficBandwidth(startDate, endDate, videoId) {
    let ret = await httpClient.get(
      `/analytics/traffic?start_date=${startDate}&end_date=${endDate}&video_id=${videoId}`
    )
    return ret
  },
  async getTrafficRanking(dates) {
    const ret = await httpClient.get(
      `/analytics/traffic/?rank_videos=11&start_date=${dates[0]}&end_date=${dates[1]}`
    )
    return ret
  },
  async getVideoTraffic(videoId, dates) {
    const ret = await httpClient.get(
      `/analytics/traffic?video_id=${videoId}&start_date=${dates[0]}&end_date=${dates[1]}`
    )
    return ret
  },
  async getVideoMetrics(videoId, startDate, endDate) {
    let url = `/analytics/video/${videoId}?a=1`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }

    let ret = await httpClient.get(url)
    return ret
  },
  async getVideoMetricsV2(videoId, startDate, endDate) {
    let url = `/analytics/video_v2/${videoId}?type=retention`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }

    let ret = await httpClient.get(url)
    return ret
  },
  async getVideoDataV2(videoId, startDate, endDate) {
    let url = `/analytics/video_v2/${videoId}?type=video`
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }

    let ret = await httpClient.get(url)
    return ret
  },
  async getVideosDataV2(startDate, endDate, videos) {
    const { data } = await httpClient.post(
      `analytics/video_v2?start_date=${startDate}&end_date=${endDate}&type=many`,
      { video_ids: videos }
    )
    return data
  },
  async getAccountMetrics(startDate, endDate) {
    let url = '/analytics/video?a=1'
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getAccountMetricsV2(startDate, endDate) {
    let url = '/analytics/video_v2?type=account'
    if (startDate) {
      url += `&start_date=${startDate}`
    }
    if (endDate) {
      url += `&end_date=${endDate}`
    }
    let ret = await httpClient.get(url)
    return ret
  },
  async getRanking(date) {
    let ret = await httpClient.get(
      `/analytics/video?type=ranking${
        date && `&start_date=${date}&end_date=${date}`
      }`
    )
    return ret
  },
  async getRankingV2(date) {
    let ret = await httpClient.get(
      `/analytics/video_v2?type=ranking${
        date && `&start_date=${date}&end_date=${date}`
      }`
    )
    return ret
  },
}
